import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { eventsOperations } from 'ducks/events';
import Catalog from 'components/Catalog';
import EventCard from 'components/cards/EventCard';
import Container from 'components/Container';
import Controls from './Controls';

const CatalogEvents = ({ total, urlParams, limit }) => {
	const dispatch = useDispatch();

	const { items } = useSelector((state) => state.events);
	const isLoading = useSelector((state) => state.events.loading);

	const gerMoreItems = () => {
		dispatch(
			eventsOperations.getEventsCatalog({
				...urlParams,
				limit,
				page: Math.ceil(items.length / limit) + 1
			})
		);
	};

	return (
		<Container>
			<Catalog
				controlsTop={<Controls urlParams={urlParams} />}
				limit={limit}
				onMoreButtonClick={gerMoreItems}
				title="Афиша"
				total={total}
				visibleTotal={items.length}
				isLoading={isLoading}
			>
				{items.map((event) => (
					<EventCard event={event} key={event._id} />
				))}
			</Catalog>
		</Container>
	);
};

CatalogEvents.propTypes = {
	total: PropTypes.number.isRequired,
	urlParams: PropTypes.object,
	limit: PropTypes.number.isRequired
};

export default CatalogEvents;
